export default {
    init: function () {
        document.querySelectorAll('.password-toggle').forEach(toggle => {
            const target = document.querySelector(toggle.dataset.target);

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const type = target.getAttribute('type') === 'password' ? 'text' : 'password';
                target.setAttribute('type', type);
                toggle.classList.toggle('visible', type === 'text');
            });
        });
    }
};